import '../css/main.css'
import './style.css'
import Menu from '../common/menu.js';
import TopBar from "../common/topBar2";
import { useEffect, useState } from 'react';
import BaiscTable from '../tables/default-table.js';
import BasicPagination from '../pagination/basic.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.js';
import { useData } from '../../contexts/DataContext.js';
import DefaultLayout from '../layouts/DefaultLayout.js';
import toast from 'react-hot-toast';

export default function Clients() {
  const {pathname} = useLocation()
  const {user,selectedMicrocredit,userRole,userInfo} = useAuth()
  const data=useData()
  const [loading,setLoading]=useState(false)
  const navigate=useNavigate()

  let required_data=['external_clients']
  const [currentPage,setCurrentPage]=useState(1)
  const [updateFilters,setUpdateFilters]=useState(null)
  const [search,setSearch]=useState('')
  const [filterOptions,setFilterOptions]=useState([])
  let initial_filters={start_date:'',end_date:''}
  const [filters,setFilters]=useState(initial_filters);
  
  const [hasEnoughSearchChars, setHasEnoughSearchChars] = useState(false);

  useEffect(()=>{ 
    if(!user || data.updateTable) return
    
    if(search.length >= 3 || search.length === 0) {
      data.handleLoaded('remove',required_data)
      data._get(required_data,{external_clients:{microcredit_id:selectedMicrocredit,search:search,page:currentPage,...filters,...data.getParamsFromFilters(filterOptions)}}) 
    }
  },[user, pathname, search, currentPage, updateFilters])

  useEffect(()=>{
    data.handleLoaded('remove',required_data)
  },[updateFilters])

  useEffect(()=>{
    if(data.updateTable){
      data.setUpdateTable(null)
      data.handleLoaded('remove',required_data)
      setCurrentPage(1)
      data._get(required_data,{external_clients:{microcredit_id:selectedMicrocredit,search:search,page:1,...filters,...data.getParamsFromFilters(filterOptions)}}) 
    }
  },[data.updateTable])

  useEffect(()=>{data.setUpdateTable(Math.random())},[filters])

  useEffect(()=>{
    if((userRole=="operator" && !userInfo?.permissions?.search_external_clients?.includes('read'))){
      navigate('/dashboard')
    }
  },[userInfo])

  useEffect(() => {
    setHasEnoughSearchChars(search.length >= 3 || search.length === 0);
  }, [search]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('pt-MZ', {
      style: 'currency',
      currency: 'MZN'
    }).format(amount);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('pt-PT');
  };

  return (
    <>
      <DefaultLayout>
        <main className="dashboard-container">
          <div className="dashboard">
            <Menu/>
            <div className="main-dashboard">
              <TopBar activePage={'Consulta Externa de Clientes'}/>
              
              <div className="center">
                <div className="center_search">
                  <div className="search_container">
                    <div className="search-div">
                      <input 
                        type="text" 
                        placeholder="Pesquisar clientes..." 
                        value={search} 
                        onChange={(e)=>{
                          setSearch(e.target.value)
                          data.setUpdateTable(Math.random())
                        }}
                        className="focus:ring-2 focus:ring-blue-500"
                      />
                      <div className="search-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg>
                      </div>
                    </div>
                  </div>

                  {!(!search.length || search.length < 3) && <div className="flex items-center">
                    <div onClick={()=> data.setUpdateTable(Math.random())} 
                         className="mr-2 cursor-pointer hover:opacity-65">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z"/></svg>
                    </div>
                  </div>}
                  
                </div>

                <div className="dasboard-item-list-container">
                  {!(!search.length || search.length < 3) && data._loaded.includes('external_clients') && <div className="top-section">
                    <div className="left-side">
                      <div className="show">
                        <span>Resultados:</span>
                        <label>{data._external_clients?.total || 0}</label>
                      </div>
                    </div>
                    <div className="right-side"></div>
                  </div>}

                  {!search.length || search.length < 3 ? (
                    <div className="flex flex-col items-center justify-center py-12 px-4 text-center bg-white rounded-lg shadow-sm">
                      <div className="max-w-md w-full">
                        <svg className="mx-auto h-12 w-12 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <h3 className="mt-4 text-lg font-medium text-gray-900">
                          Explore nossa base de clientes
                        </h3>
                        <p className="mt-2 text-sm text-gray-500">
                          Digite o nome do cliente para pesquisar em nosso inventário completo de clientes e acessar informações em outras microcréditos.
                        </p>
                        <div className="mt-6">
                          <button 
                            type="button" 
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                            onClick={() => document.querySelector('.search-div input').focus()}
                          >
                            <svg className="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                            </svg>
                            Iniciar pesquisa
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <BaiscTable  
                      loaded={data._loaded.includes('external_clients')} 
                      header={[
                        'ID',
                        'Nome',
                        'Email',
                        'Contacto Principal',
                        'Microcrédito',
                        'Gestor',
                        'Endereço',
                        'Total Contratos',
                        'Contratos Atrasados',
                        'Pagamentos Atrasados',
                        'Data Último Contracto'
                      ]}
                      body={(data._external_clients?.data || []).map((i,_i)=>(
                        <BaiscTable.Tr>
                          <BaiscTable.Td>{i.id}</BaiscTable.Td>
                          <BaiscTable.Td>{i.name}</BaiscTable.Td>
                          <BaiscTable.Td>{i.email || '-'}</BaiscTable.Td>
                          <BaiscTable.Td>{i.primaryContact || '-'}</BaiscTable.Td>
                          <BaiscTable.Td>{i.microcredit.name || '-'}</BaiscTable.Td>
                          <BaiscTable.Td>{i.managers.filter((i,_i)=>_i <= 0).map(m => 
                            m.contact 
                              ? `${m.name} (${m.contact})` 
                              : m.name
                            ).join(', ')}
                          </BaiscTable.Td>
                          <BaiscTable.Td>{i.address || '-'}</BaiscTable.Td>
                          <BaiscTable.Td>
                            <div className="text-center">
                              <div className="text-lg font-semibold text-blue-600">
                                {i.contractStats.totalContracts}
                              </div>
                              <div className="text-xs text-gray-500">
                                {i.contractStats.totalPaidContracts} pago(s)
                              </div>
                            </div>
                          </BaiscTable.Td>
                          <BaiscTable.Td>
                            {i.contractStats.totalDelayedContracts > 0 ? (
                              <div className="text-center">
                                <div className="text-lg font-semibold text-orange-600">
                                  {i.contractStats.totalDelayedContracts}
                                </div>
                                <div className="text-xs text-orange-500">
                                  de {i.contractStats.totalContracts} total
                                </div>
                              </div>
                            ) : (
                              <div className="text-center">
                                <div className="text-lg font-semibold text-green-600">
                                  0
                                </div>
                                <div className="text-xs text-green-500">
                                  Todos em dia
                                </div>
                              </div>
                            )}
                          </BaiscTable.Td>
                          <BaiscTable.Td>
                            {i.contractStats.totalDelayedPayments > 0 ? (
                              <div className="text-center">
                                <div className="text-xs text-red-500">
                                  {i.contractStats.totalDelayedInstallments} Parcela(s)
                                </div>
                              </div>
                            ) : (
                              <div className="text-center text-green-600 font-medium">
                                Em dia
                              </div>
                            )}
                          </BaiscTable.Td>
                          <BaiscTable.Td>
                            {formatDate(i.contractStats.lastContractDate)}
                          </BaiscTable.Td>
                        </BaiscTable.Tr>
                      ))}
                    />
                  )}

                <BasicPagination show={data._loaded.includes('external_clients') && !(!search.length || search.length < 3)} from={'external_clients'} setCurrentPage={setCurrentPage} total={data._external_clients?.total}  current={data._external_clients?.currentPage} last={data._external_clients?.totalPages}/>

                </div>
              </div>
            </div>
          </div>
        </main>
      </DefaultLayout>
    </>
  );
}